define(function(require) {
    var $ = require("jquery");

    function highlightCampaignContactFields() {
        // prevent .parent().parent() without classes from messing up other pages
        if ($("span.field-validation-error").closest(".enrollment-step").length > 0) return;
        // vvv--- better to scope this to a parent class or Id
        $('span.field-validation-error:visible').each(function (index, element) {
            $(element).parent().parent().addClass('is-error');
        });
    }

    function undoCampaignContactFieldHighlights() {
        // prevent .parent().parent() without classes from messing up other pages
        if ($("span.field-validation-error").closest(".enrollment-step").length > 0) return;
        // vvv--- better to scope this to a parent class or Id
        $('span.field-validation-error').each(function (index, element) {
            $(element).parent().parent().removeClass('is-error');
        });
    }

    undoCampaignContactFieldHighlights();
    highlightCampaignContactFields();

    function createValidationSummary(formId) {
        $('div.validation-summary-errors').remove();
        var errorMessages = $('span.field-validation-error:visible').map(function () {
            return $.trim($(this).text());
        }).get();

        var valueToRemove = "";

        errorMessages = $.grep(errorMessages, function (value) {
            return value !== valueToRemove;
        });

        var errorMessageCount = $(errorMessages).length;
        var $form = $('form#' + formId);
        var listHtml = "";
        $form.before("<div id='javascriptValidationSummary' class='validation-summary-errors form-error-text'>");

        listHtml += "<strong id='javascriptValidationCount' class='form-error-text'>" + errorMessageCount + $('.hidden.validation-error-count').html() + "</strong>";
        listHtml += "<ul id='javascriptValidationUl'>";
        $(errorMessages).each(function (index, element) {
            listHtml += ("<li>" + element + "</li>");
        });
        listHtml += "</ul>";
        $(listHtml).appendTo('#javascriptValidationSummary');
    }

    $("#scheduleSubmitButton").click(function(e) {
        e.preventDefault();

        undoCampaignContactFieldHighlights();

        $('span.field-validation-error.form-error-hint').hide();

        var isValid = true;
        var firstName = $("#first-name").val().trim();
        var lastName = $("#last-name").val().trim();
        var phoneNumber = $("#phone-number").val().trim();

        if (!firstName) {
            isValid = false;
            $("#firstNameError").show();
        }

        if (!lastName) {
            isValid = false;
            $("#lastNameError").show();
        }

        var phoneRe = /^[1]?\d{10}$/;
        var digits = phoneNumber.replace(/\D/g, "");
        var phoneValid = (digits.match(phoneRe) !== null);

        if (!phoneNumber || !phoneValid) {
            isValid = false;
            $("#phoneNumberError").show();
        }

        if (isValid) {
            undoCampaignContactFieldHighlights();
            $('javascriptValidationSummary').remove();
            $('form#campaignContactForm').submit();
        } else {
            highlightCampaignContactFields();
            createValidationSummary("campaignContactForm");
            $(document).scrollTop($("#campaignContactTop").offset().top);
        }
    });
});
